export const translations = {
    vi: {
        app_title: "PlayPay",
        loading: "Đang tải PlayPay...",
        login_success: "Đăng nhập thành công",
        password_wrong: "Mật khẩu không đúng!",
        enter_admin_password: "Nhập mật khẩu quản trị",
        password_placeholder: "Mật khẩu...",
        confirm: "Xác nhận",
        create_new_session: "Tạo buổi mới",
        session_date: "Ngày",
        session_name_optional: "Tên buổi (tùy chọn)",
        create: "Tạo",
        sessions_list: "Các buổi chơi",
        your_sessions: "Buổi của bạn",
        add_player: "Thêm người chơi",
        player_list: "Danh sách người chơi",
        bad_debt: "Nợ xấu",
        view_all_unpaid: "Xem tất cả lịch sử người chưa thanh toán",
        login: "Đăng nhập",
        logout: "Đăng xuất",
        total: "Tổng",
        paid: "Đã trả",
        unpaid: "Chưa trả",
        add_new_player_placeholder: "Thêm người chơi mới...",
        save: "Lưu",
        cancel: "Hủy",
        name: "Tên",
        photo: "Ảnh",
        no_players_yet: "Chưa có người chơi nào",
        bad_debt_ranking: "Xếp hạng nợ xấu",
        loading_data: "Đang tải dữ liệu...",
        all_paid: "Tất cả đã thanh toán!",
        players: "Người chơi",
        expand: "Mở rộng",
        collapse: "Thu gọn",
        add_player_to_session: "Thêm người chơi vào buổi này",
        add: "Thêm",
        add_shuttlecock_box: "Thêm hộp cầu lông",
        box_name_placeholder: "Tên hộp (VD: Hộp 1)",
        price: "Giá (kr)",
        shuttlecock_count: "Số cầu",
        add_field_booking: "Thêm đặt sân",
        field_name_placeholder: "Tên sân (VD: Sân A)",
        hours: "Số giờ",
        price_per_hour: "Giá/giờ (kr)",
        total_preview: "Tổng",
        shuttlecock_boxes: "Hộp cầu",
        per_shuttlecock: "kr/cầu",
        used: "Đã dùng",
        cost: "Chi phí",
        field_bookings: "Đặt sân",
        hour_short: "giờ",
        per_hour: "kr/giờ",
        delete_booking_confirm: "Xóa đặt sân này?",
        individual_play_hours: "Giờ chơi của từng người",
        split_by_ratio: "kr chia theo tỷ lệ giờ",
        player_count: "Số người chơi",
        total_field_cost: "Tổng chi phí sân",
        cost_split: "Phân chia chi phí",
        field: "Sân",
        box: "Cầu",
        include_box: "Tính cầu",
        exclude_box: "Không tính cầu",
        include_box_tooltip: "Bao gồm chi phí cầu",
        exclude_box_tooltip: "Loại bỏ chi phí cầu",
        settlement_note: "✓ Nhấp vào ô tròn để đánh dấu đã trả | 🎾 Nhấp vào nút cầu để loại bỏ chi phí cầu",
        delete: "Xóa",
        edit: "Sửa",
        image_upload_failed: "Tải ảnh thất bại",
        save_changes_failed: "Lưu thay đổi thất bại",
        name_empty: "Tên không được để trống",
        participant_saved: "Đã lưu thông tin người chơi",
        session_default_name: "Buổi chơi",
        monday: "Thứ Hai",
        tuesday: "Thứ Ba",
        wednesday: "Thứ Tư",
        thursday: "Thứ Năm",
        friday: "Thứ Sáu",
        saturday: "Thứ Bảy",
        sunday: "Chủ Nhật",
        set_all: "Chia đều",
        clear_all: "Xóa hết",
        preload_defaults: "Tự động tạo chi phí mặc định",
        select_participants: "Chọn người chơi",
        search_players: "Tìm người chơi...",
        swish_number: "Số Swish",
        delete_session_title: "Xóa buổi chơi",
        confirm_delete_session: "Bạn có chắc chắn muốn xóa buổi chơi này không? Toàn bộ chi phí và dữ liệu thanh toán liên quan sẽ bị mất.",
        archive_session_title: "Lưu trữ buổi chơi",
        confirm_archive_session: "Bạn có chắc chắn muốn kết thúc và lưu trữ buổi chơi này?",
        session_archived: "Đã lưu trữ buổi chơi",
        complete: "Hoàn tất",
        session_deleted: "Đã xóa buổi chơi",
        error_occurred: "Có lỗi xảy ra",
        remove_player: "Loại bỏ người chơi",
        confirm_remove_player_prefix: "Bạn có chắc chắn muốn loại bỏ",
        confirm_remove_player_suffix: "khỏi buổi chơi này không?",
        player_removed: "Đã loại bỏ người chơi",
        clear_hours_title: "Xóa tất cả giờ chơi",
        confirm_clear_hours: "Bạn có chắc chắn muốn xóa tất cả giờ chơi đã nhập cho khoản phí này không?",
        hours_cleared: "Đã xóa giờ chơi cho tất cả",
        delete_expense_title: "Xóa khoản phí",
        confirm_delete_expense_prefix: "Bạn có chắc chắn muốn xóa",
        confirm_delete_expense_suffix: "Tất cả dữ liệu liên quan sẽ bị mất.",
        expense_deleted: "Đã xóa khoản phí",
        delete_player_title: "Xóa người chơi",
        confirm_delete_player: "Bạn có chắc chắn muốn xóa người chơi này không? Toàn bộ lịch sử thanh toán liên quan sẽ bị ảnh hưởng.",
        player_deleted: "Đã xóa người chơi",
        menu: "Menu",
        light: "Sáng",
        dark: "Tối",
        today: "Hôm nay",
        edit_player: "Sửa người chơi",
        upload_photo: "Ảnh",
        change_photo: "Đổi ảnh",
        remove_photo: "Xóa ảnh",
        image_selected: "Đã chọn ảnh",
        name_placeholder: "Tên",
        save_success: "Lưu thành công",
        add_success: "Đã thêm người chơi",
        add_failed: "Thêm thất bại",
        image_upload_error: "Lỗi tải ảnh",
        uploading: "Đang tải lên...",
        empty_name_error: "Tên không được để trống",
        language: "Ngôn ngữ",
        manage_hours: "Quản lý giờ chơi",
        unit: "Quả",
        close: "Đóng",
        total_used: "Quả",
        total_hours_full: "Giờ",
        swish_copied: "Đã sao chép số Swish",
        excludes_box_short: "Không tính cầu",
        includes_box_short: "Tính tiền cầu",
        added_players_success: "Thêm người chơi thành công",
        set_all_hours_success: "Đã đặt giờ cho tất cả người chơi",
        cost_unit: "phí",
        change_language: "Chọn ngôn ngữ",
        open_menu: "Mở menu",
        archive_tooltip: "Hoàn tất & Lưu trữ",
        delete_tooltip: "Xóa buổi chơi",
        logout_success: "Đã đăng xuất",
        no_bad_debts: "Không có nợ xấu nào cần xử lý.",
        shuttlecock: "Cầu lông",
        court: "Sân",
        session_not_found: "Buổi chơi không tồn tại hoặc đã bị xóa",
        no_results_found_for: "Không tìm thấy kết quả cho",
        unknown: "Không xác định",
        failed_sync_session: "Lỗi đồng bộ dữ liệu buổi chơi",
        copy_number_tooltip: "Sao chép số",
        sign_in_with_google: "Đăng nhập bằng Google",
        sign_in_subtitle: "Đăng nhập để tạo và quản lý buổi chơi",
        sign_out: "Đăng xuất",
        signed_in_as: "Đăng nhập với",
        sign_in_required: "Bạn cần đăng nhập để thực hiện",
        session_owner: "Chủ buổi",
        auth_error: "Lỗi xác thực",
        only_owner_can_edit: "Chỉ người tạo mới có thể chỉnh sửa",
        auth_public_note: "Buổi chơi luôn công khai • Chỉ người tạo mới có thể chỉnh sửa",
        session_created: "Tạo buổi chơi thành công",
        profile_settings: "Cài đặt hồ sơ",
        your_swish_number: "Số Swish của bạn",
        swish_number_hint: "Tự động điền khi tạo buổi chơi",
        linked_participant: "Người chơi liên kết",
        link_participant_hint: "Liên kết tài khoản với hồ sơ người chơi",
        select_participant_to_link: "Chọn người chơi để liên kết...",
        profile_saved: "Đã lưu hồ sơ",
        verified_player: "Đã xác minh",
        unlink: "Hủy liên kết",
        no_participant_linked: "Chưa liên kết người chơi",
        showing: "Hiển thị",
        of: "trên",
        filter_by_name: "Tìm theo tên...",
        field_updated: "Đã cập nhật đặt sân",
        field_update_failed: "Lỗi cập nhật đặt sân",
        toggle_admin_fee: "Thêm phí quản lý",
        admin_fee_label: "Phí quản lý (%)",
        admin_fee: "Phí quản lý",
        admin_fee_description: "Chia đều cho tất cả người chơi",
        per_person: "người"
    },
    en: {
        app_title: "PlayPay",
        loading: "Loading PlayPay...",
        login_success: "Login successful",
        password_wrong: "Incorrect password!",
        enter_admin_password: "Enter Admin Password",
        password_placeholder: "Password...",
        confirm: "Confirm",
        create_new_session: "Create New Session",
        session_date: "Date",
        session_name_optional: "Session Name (Optional)",
        create: "Create",
        sessions_list: "Sessions",
        your_sessions: "Your Sessions",
        add_player: "Add Player",
        player_list: "Player List",
        bad_debt: "Bad Debt",
        view_all_unpaid: "View all unpaid history",
        login: "Login",
        logout: "Logout",
        total: "Total",
        paid: "Paid",
        unpaid: "Unpaid",
        add_new_player_placeholder: "Add new player...",
        save: "Save",
        cancel: "Cancel",
        name: "Name",
        photo: "Photo",
        no_players_yet: "No players yet",
        bad_debt_ranking: "Debt Ranking",
        loading_data: "Loading data...",
        all_paid: "All paid!",
        players: "Players",
        expand: "Expand",
        collapse: "Collapse",
        add_player_to_session: "Add players to this session",
        add: "Add",
        add_shuttlecock_box: "Add Shuttlecock Box",
        box_name_placeholder: "Box Name (e.g. Box 1)",
        price: "Price (kr)",
        shuttlecock_count: "Shuttlecock Count",
        add_field_booking: "Add Field Booking",
        field_name_placeholder: "Field Name (e.g. Court A)",
        hours: "Hours",
        price_per_hour: "Price/Hour (kr)",
        total_preview: "Total",
        shuttlecock_boxes: "Shuttlecock Boxes",
        per_shuttlecock: "kr/unit",
        used: "Used",
        cost: "Cost",
        field_bookings: "Field Bookings",
        hour_short: "h",
        per_hour: "kr/h",
        delete_booking_confirm: "Delete this booking?",
        individual_play_hours: "Individual Play Hours",
        split_by_ratio: "kr split by hour ratio",
        player_count: "Players",
        total_field_cost: "Total Field Cost",
        cost_split: "Cost Split",
        field: "Field",
        box: "Box",
        include_box: "Incl. Shuttles",
        exclude_box: "Excl. Shuttles",
        include_box_tooltip: "Include shuttlecock cost",
        exclude_box_tooltip: "Exclude shuttlecock cost",
        settlement_note: "✓ Click circle to mark as paid | 🎾 Click box button to exclude shuttlecock cost",
        delete: "Delete",
        edit: "Edit",
        image_upload_failed: "Image upload failed",
        save_changes_failed: "Failed to save changes",
        name_empty: "Name cannot be empty",
        participant_saved: "Participant saved successfully",
        session_default_name: "Session",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        set_all: "Split equally",
        clear_all: "Clear all",
        preload_defaults: "Auto-create default expenses",
        select_participants: "Select participants",
        search_players: "Search players...",
        swish_number: "Swish Number",
        delete_session_title: "Delete Session",
        confirm_delete_session: "Are you sure you want to delete this session? All associated expenses and payments will be lost.",
        archive_session_title: "Archive Session",
        confirm_archive_session: "Are you sure you want to complete and archive this session?",
        session_archived: "Session archived",
        complete: "Complete",
        session_deleted: "Session deleted",
        error_occurred: "An error occurred",
        remove_player: "Remove Player",
        confirm_remove_player_prefix: "Are you sure you want to remove",
        confirm_remove_player_suffix: "from this session?",
        player_removed: "Player removed",
        clear_hours_title: "Clear All Hours",
        confirm_clear_hours: "Are you sure you want to clear all hours for this expense?",
        hours_cleared: "Hours cleared for everyone",
        delete_expense_title: "Delete Expense",
        confirm_delete_expense_prefix: "Are you sure you want to delete",
        confirm_delete_expense_suffix: "All associated data will be lost.",
        expense_deleted: "Expense deleted",
        delete_player_title: "Delete Player",
        confirm_delete_player: "Are you sure you want to delete this player? All payment history will be affected.",
        player_deleted: "Player deleted",
        menu: "Menu",
        light: "Light",
        dark: "Dark",
        today: "Today",
        edit_player: "Edit Player",
        upload_photo: "Photo",
        change_photo: "Change",
        remove_photo: "Remove",
        image_selected: "Image selected",
        name_placeholder: "Name",
        save_success: "Save successful",
        add_success: "Player added",
        add_failed: "Failed to add",
        image_upload_error: "Image upload error",
        uploading: "Uploading...",
        empty_name_error: "Name cannot be empty",
        language: "Language",
        manage_hours: "Manage Hours",
        unit: "unit",
        close: "Close",
        total_used: "Used",
        total_hours_full: "Hours",
        swish_copied: "Swish number copied",
        excludes_box_short: "Excludes box",
        includes_box_short: "Includes box",
        added_players_success: "Players added successfully",
        set_all_hours_success: "Set hours for all players",
        cost_unit: "cost",
        change_language: "Change Language",
        open_menu: "Open Menu",
        archive_tooltip: "Complete & Archive",
        delete_tooltip: "Delete session",
        logout_success: "Logged out successfully",
        no_bad_debts: "No bad debts to handle.",
        shuttlecock: "Shuttlecock",
        court: "Court",
        session_not_found: "Session no longer available or deleted",
        no_results_found_for: "No results found for",
        unknown: "Unknown",
        failed_sync_session: "Failed to sync session data",
        copy_number_tooltip: "Copy number",
        sign_in_with_google: "Sign in with Google",
        sign_in_subtitle: "Sign in to create and manage sessions",
        sign_out: "Sign Out",
        signed_in_as: "Signed in as",
        sign_in_required: "Sign in required",
        session_owner: "Owner",
        auth_error: "Authentication error",
        only_owner_can_edit: "Only the creator can edit this session",
        auth_public_note: "Sessions are always public • Only creators can edit",
        session_created: "Session created successfully",
        profile_settings: "Profile Settings",
        your_swish_number: "Your Swish Number",
        swish_number_hint: "Auto-fills when creating sessions",
        linked_participant: "Linked Player",
        link_participant_hint: "Link your account to a player profile",
        select_participant_to_link: "Select player to link...",
        profile_saved: "Profile saved",
        verified_player: "Verified",
        unlink: "Unlink",
        no_participant_linked: "No player linked",
        showing: "Showing",
        of: "of",
        filter_by_name: "Filter by name...",
        field_updated: "Field booking updated",
        field_update_failed: "Failed to update field booking",
        toggle_admin_fee: "Add admin fee",
        admin_fee_label: "Admin fee (%)",
        admin_fee: "Admin fee",
        admin_fee_description: "Split equally among all players",
        per_person: "person"
    }
};
